import React, { useState, useRef } from "react";
import { Input, Modal, ModalBody, ModalHeader } from "reactstrap";
import { AnimatePresence, motion } from "framer-motion";

import arrowDown from "../../assets/images/arrow-down.png";
import arrowUp from "../../assets/images/arrow-up.png";
import _ from "lodash";
import dummyavatar from "../../assets/images/verboden/user.png";
import * as socketAction from "../../redux/sockets/action";
import { withRouter } from "react-router";
import { compose } from "redux";
import { connect } from "react-redux";

const fadeVariants = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: {
      delay: 0.09,
    },
  },
  exit: {
    opacity: 0,
  },
};

function InviteTeammatesModal(props) {
  const params = _.get(
    props,
    "gameReducer.gamesData.challenges.participants.edit"
  );
  const currentTeamMembers = props.current_user?.team?.users;

  const [openTeamDropdown, setOpenTeamDropdown] = useState(false);

  const invitedIdsRef = useRef([]);

  const handleChangeInviteTeammates = (item) => {
    let invitedPlayers = [...props.socketReducer.invitedPlayers];
    if (!!invitedPlayers.find((player) => player.Username == item.Username)) {
      invitedPlayers = invitedPlayers.filter(
        (player) => player.Username !== item.Username
      );
    } else {
      invitedPlayers.push(item);
    }

    props.setInvitedPlayers(invitedPlayers);
  };

  return (
    <Modal
      centered
      isOpen={props.modal}
      toggle={props.modalToggle}
      className="invite-teammates-modal"
    >
      <ModalHeader toggle={props.modalToggle}>{params?.label}</ModalHeader>
      <ModalBody>
        <p className="text">{params?.text}</p>
        <div className="mb-5 mt-3">
          <div className="team-challenge-dropdown">
            <div
              className="dropdown-flex"
              onClick={() => setOpenTeamDropdown(!openTeamDropdown)}
            >
              <p className="mb-0">
                {props.socketReducer.invitedPlayers.length > 0
                  ? props.socketReducer?.invitedPlayers[0]?.name +
                    "," +
                    "+" +
                    (props.socketReducer.invitedPlayers.length - 1) +
                    "More"
                  : "Teammate Name"}
              </p>
              <img
                src={`${openTeamDropdown ? arrowUp : arrowDown}`}
                className="arrow-icon"
                alt=""
              />
            </div>
            <AnimatePresence>
              {openTeamDropdown && (
                <motion.div
                  initial="hidden"
                  animate="visible"
                  exit="exit"
                  variants={fadeVariants}
                  className="team-challenge-dropdown-div"
                >
                  {currentTeamMembers &&
                    currentTeamMembers.map((item, index) => {
                      return (
                        <div
                          className="dropdown-item"
                          onClick={() => handleChangeInviteTeammates(item)}
                        >
                          <Input
                            id={index}
                            type="checkbox"
                            name="check"
                            checked={
                              !!props.socketReducer.invitedPlayers.find(
                                (player) => player.Username === item.Username
                              )
                            }
                          />
                          <img
                            src={item.picture ? item.picture : dummyavatar}
                            alt=""
                          />
                          <p className="name">{item.name}</p>
                        </div>
                      );
                    })}
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
}

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,

  socketReducer: state.socketReducer,
});
const mapDispatchToProps = (dispatch) => {
  return {
    setInvitedPlayers: (data) => dispatch(socketAction.setInvitedPlayers(data)),
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(InviteTeammatesModal);
